

























import { Component, Mixins } from "vue-property-decorator";
import OutsideView from "./OutsideView.vue";
import viewMetaMixin from "@/mixins/viewMetaMixin";
import onLocaleChangeMixin from "@/mixins/onLocaleChangeMixin";
import { updateItems } from "@/lib";
import { INewsData, IBeautyPlaceData } from "@/entities";
import NewsPreviewCard from "@/components/cards/NewsPreviewCard.vue";
@Component({
  components: {
    OutsideView,
    NewsPreviewCard,
  },
})
export default class News extends Mixins(viewMetaMixin, onLocaleChangeMixin) {
  mounted() {
    this.$store.dispatch("setCheckboxLabelColor", true);
  }
  protected initFetches = [this.FetchPlaces, this.fetchNews];
  protected reFetches = [this.FetchPlaces, this.fetchNews];
  get title(): string {
    return this.$t("titles.news") + " ".toLocaleUpperCase();
  }

  private news: INewsData[] = [];
  private places: IBeautyPlaceData[] = [];
  protected fetchingNews: boolean = false;
  protected fetchingPlaces: boolean = false;

  get mayHaveItems(): boolean {
    return (
      !!this.news.length ||
      this.fetchingNews ||
      !!this.places.length ||
      this.fetchingPlaces
    );
  }
  private fetchNews(): void {
    if (this.fetchingNews) return;
    this.fetchingNews = true;

    this.$storage.actions
      .fetchNews()
      .then((res) => {
        this.news = res;
      })
      .catch(() => {})
      .finally(() => {
        this.fetchingNews = false;
      });
  }

  private FetchPlaces(): void {
    if (this.fetchingPlaces) return;
    this.fetchingPlaces = true;

    this.$storage.actions
      .fetchBeautyPlaces()
      .then((res) => {
        this.places = res;
      })
      .catch(() => {})
      .finally(() => {
        this.fetchingPlaces = false;
      });
  }
  private UpdateNews(): void {
    updateItems<INewsData>(this.news, this.$storage.actions.getNewsById);
  }
  private UpdatePlaces(): void {
    updateItems<IBeautyPlaceData>(
      this.places,
      this.$storage.actions.getBeautyPlaceById
    );
  }
}
